const MapGLToken = 'pk.eyJ1IjoiZmlyc3R0YWJsZSIsImEiOiJjanF5aWx0a3IwMG51NDNubTg0NGlvbG1lIn0.JAzg5FWGnxY-SIUfX-ZVmg';

export { MapGLToken }; // eslint-disable-line
